import _ from 'lodash';
import STRoles from './roles';
import AllPermissions from './permissions/allPermissions';

export const To = _.mapValues(AllPermissions, (value, key) => key);
export const Roles = _.map(STRoles, role => role);

export const RolesGuard = {
  letMe(permissionTitle, role) {
    const permission = RolesGuard._getPermission(permissionTitle);
    if (!permission) {
      console.error(`[RolesGuard.letMe] Error: Permission ${permissionTitle} not found.`);
      return false;
    }

    if (_.isString(role) && RolesGuard._havingAMatchingRole(Roles, role)) {
      return RolesGuard._havingAMatchingRole(permission, role);
    }
    return false;
  },

  _getPermission(permissionTitle) {
    return AllPermissions[permissionTitle];
  },

  _havingAMatchingRole(roles, role) {
    const indexOfRoleMatcher = _.indexOf(roles, role);
    return indexOfRoleMatcher !== -1;
  },
};

export default { RolesGuard, Roles, To };
